import { Component, useCallback, useState } from "react"
import Image from "../Common/Image"
import img from "../../assets/ErrorBoundary/vid1.gif"
import GenericButton from "../Common/GenericButton"
import AppStore from "../../Configs/Store/index"

const Error = () => {
  const [state, updateState] = useState()
  const reloadComponent = useCallback(() => updateState({}), [])

  console.log("Re-rendering..")

  return (
    <div style={{ textAlign: "center", fontSize: "22px", marginBottom: "10px" }}>
      <Image style={AppStore.device === 0 ? { width: "40%" } : { width: "20%" }} src={img} alt={"gif"} />
      <div>Component Crashed !</div>
      <GenericButton title={"Reload"} onClick={reloadComponent} />
    </div>
  )
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
    }
  }

  componentDidCatch(error, info) {
    console.log(error)
    console.log(info)
  }

  render() {
    if (this.state.hasError) {
      return <Error />
    }
    return this.props.children
  }
}

export default ErrorBoundary
